import { render, staticRenderFns } from "./sysCorpManage.vue?vue&type=template&id=5259f173&"
import script from "./sysCorpManage.vue?vue&type=script&lang=js&"
export * from "./sysCorpManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports